import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notifications: null,
};

export const NotificationSlice = createSlice({
  name: "NotificationSlice",
  initialState,
  reducers: {
    setNotifications: (state, { payload }) => {
      state.notifications = payload;
    },
    setUpdateNotification: (state, { payload }) => {
      const index = state.notifications.findIndex(
        (ls) => ls?._id === payload?._id
      );
      if (index >= 0) {
        state.notifications[index] = payload;
      }
    },
  },
});

export const { setNotifications, setUpdateNotification } =
  NotificationSlice.actions;
export default NotificationSlice.reducer;
